import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



export const EventRowTitle = withConfig(theme => styled('div', { label: 'EventRowTitle' })<{variant?: DefaultComponentVariantType | null}>`

    ${({ variant }): SerializedStyles => setEventRowTitle(variant, theme)};

    max-width: 100%;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

`);



const setEventRowTitle = (variant: DefaultComponentVariantType | null = null, theme: EmotionTheme): SerializedStyles => {

  if (variant === DefaultComponentVariantType.TERTIARY) {

    return css`

        font-size: ${theme.star.unified.eventRow.typography.fontSizePrimary};

        font-weight: ${theme.star.unified.eventRow.typography.fontWeightPrimary};

        line-height: ${theme.star.unified.eventRow.typography.lineHeightPrimary};

    `;

  }

  return css`

      font-size: ${theme.star.eventRow.typography.fontSizePrimary};

      font-weight: ${theme.star.eventRow.typography.fontWeightPrimary};

      line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

  `;

}



const setMobileParticipant = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

  if (variant === DefaultComponentVariantType.TERTIARY) {

    return css`

        width: 100%;

        display: flex;

        gap: ${theme.star.gap.medium};

        align-items: center;

        color: ${theme.star.unified.eventRow.txtColor};

        font-size: 1.4rem;

        font-weight: ${theme.star.unified.eventRow.typography.fontWeightPrimary};

        line-height: ${theme.star.unified.eventRow.typography.lineHeightPrimary};

    `;

  }

  return css`

      color: ${theme.star.eventRow.txtColor};

      font-size: ${theme.star.eventRow.typography.fontSizePrimary};

      font-weight: ${theme.star.eventRow.typography.fontWeightPrimary};

      line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

  `;

}



export const MobileParticipant = withConfig(theme => styled('div', { label: 'MobileParticipant' })<{variant: DefaultComponentVariantType | null}>`

    ${({ variant }): SerializedStyles => setMobileParticipant(variant, theme)};

`);



export const Score = withConfig(theme => styled('span', { label: 'Score' })`

    display: inline-flex;

    font-weight: ${theme.star.fontWeight.bold};

    justify-content: center;

    color: ${theme.star.unified.score.color.txtPrimary};

    margin-left: auto;

`);

